// The AcyMart brand palette, for JS that has to hand a colour to an inline
// style or an SVG attribute. Everything here is a CSS custom-property
// reference rather than a literal hex, so values follow the light/dark theme
// swap defined in App.css's :root blocks automatically -- never hardcode a
// hex duplicate of these.
//
// The interface is restricted to four hues: Navy, Orange, Blue, White. See
// App.css's token header for the full rationale and the per-colour
// responsibilities. The practical consequence for this file is that "good"
// vs "bad" vs "needs attention" can no longer be told apart by hue, so every
// status must also carry an icon or a text label.
export const NAVY = 'var(--color-brand-navy)';
export const ORANGE = 'var(--color-brand-orange)';
export const BLUE = 'var(--color-brand-blue)';
export const WHITE = 'var(--color-brand-white)';

// Navy's foreground role, which inverts to white on the dark canvas. Use this
// (not NAVY) for text and icons that sit on the page background, so they stay
// legible in dark mode. NAVY stays literal for fills that are meant to be the
// dark brand colour in both themes.
export const NAVY_FG = 'var(--accent-secondary)';

// Text colours guaranteed to clear WCAG AA on a solid orange/blue fill --
// navy, not white (white on #FF6700 is only 2.8:1).
export const ON_ORANGE = 'var(--color-text-on-primary)';
export const ON_BLUE = 'var(--color-text-on-secondary)';

// Four semantic "tones" standing in for the old success/danger/warning/info
// hues:
//   neutral   -- structural/informational (received, submitted, dismissed)
//   positive  -- complete/good (delivered, approved, resolved)
//   attention -- needs a look, not yet resolved (pending, documents requested)
//   critical  -- negative/terminal-bad (cancelled, rejected) -- same orange
//                hue as "attention" but call sites should pair this with a
//                bold/filled treatment (not a pale tint) and an icon (e.g.
//                IconX), since colour alone can't carry "this is bad" anymore.
export const STATUS_TONE = {
  neutral:   { color: NAVY_FG, bg: `color-mix(in srgb, ${NAVY_FG} 12%, transparent)` },
  positive:  { color: BLUE,    bg: `color-mix(in srgb, ${BLUE} 12%, transparent)` },
  attention: { color: ORANGE,  bg: `color-mix(in srgb, ${ORANGE} 12%, transparent)` },
  critical:  { color: ORANGE,  bg: `color-mix(in srgb, ${ORANGE} 22%, transparent)` },
};

// Categorical chart scale. Three brand hues at three opacity steps -- see the
// --chart-* block in App.css. Charts using more than three series must also
// carry a legend or direct labels: eight steps drawn from three hues are not
// reliably separable by colour alone, and one of the three inverts between
// themes.
export const CHART_SERIES = [
  'var(--chart-1)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-4)',
  'var(--chart-5)', 'var(--chart-6)', 'var(--chart-7)', 'var(--chart-8)',
];
export const chartColor = (index) => CHART_SERIES[index % CHART_SERIES.length];

// Chart furniture (gridlines, axis ticks) -- navy-derived, theme-aware.
export const CHART_GRID = 'var(--chart-grid)';
export const CHART_AXIS = 'var(--chart-axis)';

// Decorative (non-status) tag/category colours -- also restricted to the
// brand hues, cycled since there are more categories than brand colours.
export const CATEGORY_TONE_CYCLE = [NAVY_FG, ORANGE, BLUE];
export const categoryColor = (index) => CATEGORY_TONE_CYCLE[index % CATEGORY_TONE_CYCLE.length];
